export default __webpack_public_path__ + "static/media/cloud-workstation.af176741.svg";